import { UserVerificationBridgeService } from "@modules/+new/payments/shared-payments/components/user-verification/domain/+state/user-verification-bridge.service";
import { ModalCloseReason } from "@modules/+new/shared/universal-modal/entities/modal-close-reason.enum";
import { UniversalModalService } from "@modules/+new/shared/universal-modal/universal-modal.service";
import { Injectable } from "@angular/core";

@Injectable()
export class UserVerificationFacade {
	public constructor(
		private readonly userVerificationBridge: UserVerificationBridgeService,
		private readonly modalService: UniversalModalService
	) {}

	public isVerificationPending(): boolean {
		return this.userVerificationBridge.isVerificationPending();
	}

	public verify(): void {
		this.modalService.close(ModalCloseReason.close);
		this.userVerificationBridge.openVerificationPageOrModal();
	}
}
